import get from 'lodash/get';

import { Session, SessionBidsError, SessionBidsErrorType } from '../shared/models/session.model';
import { TreeQuery } from '../shared/models/tree-query.model';

export function getSessionBidsError(session: Session): SessionBidsError {
  const bidsError: string = get(session, 'info.BIDS.error_message');
  if (bidsError) {
    return { type: SessionBidsErrorType.SessionBidsError, message: bidsError };
  }
  else if (session.satisfies_template === false) {
    return { type: SessionBidsErrorType.Template, message: "This session does not follow the project's template." };
  }
  return null;
}

/* eslint-disable quotes */
export const sessionFilesQuery: TreeQuery = Object.freeze({
  "sessions": {
    "fields": [
      "label",
      "notes",
      "parents",
      "permissions",
      "tags",
      "timestamp",
      "_id",
    ],
    "acquisitions": {
      "limit": 50,
      "fields": [
        "created",
        "info",
        "info_exists",
        "label",
        "modified",
        "tags",
        "timestamp",
        "_id",
      ],
      "files": {
        "fields": [
          "id",
          "classification",
          "copy_of",
          "created",
          "hash",
          "info",
          "info_exists",
          "mimetype",
          "modality",
          "modified",
          "name",
          "parents",
          "path",
          "size",
          "type",
          "virus_scan",
          "zip_member_count",
        ],
        "join-origin": true,
      },
    },
  },
});
/* eslint-enable quotes */
